import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-index",
  "use": "icon-index-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-index\"><path d=\"M0 0h1024v1024H0z\" fill=\"#FFFFFF\" p-id=\"2662\" /><path d=\"M493.909333 92.992a32 32 0 0 1 36.309334 0l383.936 264.661333A32 32 0 0 1 928 384v512a32 32 0 0 1-32 32H128A32 32 0 0 1 96 896V384a32 32 0 0 1 13.845333-26.346667zM544 512h-64v256h64V512z\" fill=\"#111111\" p-id=\"2663\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol